import { render, staticRenderFns } from "./RefNumSetupNew.vue?vue&type=template&id=ae2207b8"
import script from "./RefNumSetupNew.vue?vue&type=script&lang=js"
export * from "./RefNumSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports